import { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';

type Props = {
  children: ReactNode;
};

export const BrowserWrapper = ({ children }: Props) => {
  return <BrowserRouter>{children}</BrowserRouter>;
};
